export default __webpack_public_path__ + "static/ebook-707766d6bbce7a8da716065976a9e028.png";